export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-08B.a827ec70.png";